module.exports = __webpack_public_path__ + "img/fb-button.37a4923.png";